import { render, staticRenderFns } from "./Petals.vue?vue&type=template&id=6f152722&"
import script from "./Petals.vue?vue&type=script&lang=js&"
export * from "./Petals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports